<template>
  <div id="main_apply_project" class="content_step_nav_container centered" v-if="loaded">

    <breadcrumbs :items="breadcrumbsComp" />
    <div class="haed">
      <div class="title_btn">
        <div class="title">
          <h2 class="title">הגשת מועמדות במכרז</h2>
          <div class="prj_number_item">
            <h5>מספר פרויקט</h5>
            <p v-text="item.prj_number"></p>
          </div>
        </div>
        <router-link :to="mainPageLink" class="exit_btn">יציאה מהמכרז</router-link>
      </div>
      <ul class="steps">
        <div class="arrow_container" v-show="currentStep > 1" @click="moveStep('back')">
          <div class="arrow_right_icon icon"></div>
        </div>
        <li class="step" v-for="step in steps" :class="{active: currentStep === step.stepNum || ( step.stepNum === 1 && currentStep === 0)}" :key="step.stepNum">
          <span class="num" v-text="step.stepNum" v-if="currentStep <= step.stepNum"></span>
          <div class="icon_container" v-else>
            <span class="icon check_white_icon"></span>
          </div>
          <span class="name" v-text="step.name"></span>
        </li>
      </ul>
    </div>
    <div class="content">
      <existingDetails state="edit" :applying_data="applying_data" :item="item" @next="handleNext" v-if="(currentStep === 1 || currentStep === 0) && item.bid_step !== 'improve'" />
      <contractManager state="edit" :bid_step="item.bid_step" :token="token" @next="item.bid_step === 'improve' ? finish() : handleNext()" v-if="currentStep === 2" />
      <div class="content_wrapper" v-if="currentStep === 3">
           <strong>  זהו רגע חשוב ביותר בתהליך!    </strong> 
          <br>
          אנא ודא שהמסמכים שהעלית מלאים ומעודכנים, וכוללים את כל הנתונים הנדרשים – כדי שההשוואה תהיה מדויקת ותשקף את ההצעה שלך בצורה הטובה ביותר.
          <br>
          לאחר השליחה:
          <br>
            •	לא ניתן יהיה לערוך את המכרז.
          <br>
            •	המכרז יוצג לדיירים באופן אנונימי וללא פרטי קשר, עד לשלב ההתקדמות.
            <br>
            •	המערכת תעדכן אותך כשהמכרז שלך יוצג להשוואה.
                </div>
      <button class="btn send-btn"  v-if="currentStep === 3 && item.bid_step !== 'improve'" @click="finish">הגשת מועמדות</button>
      <!-- <checkout-component :token="token" @next="finish" @fail="handleFail" v-if="currentStep === 3 && item.bid_step !== 'improve'" /> -->
    </div>
  </div>
</template>

<script>
import existingDetails from '../components/applyingPrj/existingDetails'
import contractManager from '../components/applyingPrj/contractManager'
// import checkoutComponent from '../components/applyingPrj/checkoutComponent'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
    components: {existingDetails, contractManager,/* checkoutComponent, */Breadcrumbs},
    data() {
        return {
          loaded:false,
          item:[],
          applying_data:[],
          currentStep: +this.$route.params.step,
          token: (this.$route.params.token ? this.$route.params.token : false),
        }
    },
    beforeMount(){
      const res = this.checkPerms();
      if(!res || res == 'lawyer'){
        this.$router.push('/');  
      }
    },
    computed: {
      steps() {
        // Default steps for regular bid process
        if (!this.item.bid_step || this.item.bid_step !== 'improve') {
          return [
            { stepNum: 1, name: this.get_word('applay_prj_1', true) },
            { stepNum: 2, name: this.get_word('applay_prj_contract', true) || 'חוזה' },
            { stepNum: 3, name: this.get_word('apply_checkout', true) || 'סיום' },
          ];
        } 
        // Steps for 'improve' bid process - skipping step 1 and payment
        else {
          return [
            { stepNum: 2, name: this.get_word('applay_prj_contract', true) || 'חוזה' },
          ];
        }
      },
      mainPageLink() {
        return '/list';
      },
      breadcrumbsComp() {
        return this.steps.reduce((acc, step) => {
          if (this.currentStep >= step.stepNum) {
            acc.push({
              label: step.name,
              path: `/applying_project/${step.stepNum}/${this.token}`
            });
          }
          return acc;
        }, [
          { label: 'רשימת מכרזים', path: '/list' },
          { label: 'הגשת מועמדות במכרז', path: `/applying_project/1/${this.token}` }
        ]);
      }
    },
    mounted(){
      if(!this.token) return this.$router.push('/');

      this.loadData();
    },
    updated() {
      // Ensure the current step is valid for the bid type after data is loaded
      if (this.loaded && this.item.bid_step === 'improve') {
        // If we're in 'improve' mode and on step 1 or 3, redirect to step 2
        if (this.currentStep === 1 || this.currentStep === 0 || this.currentStep === 3) {
          this.$router.push('/applying_project/2/'+ this.token);
        }
      }
    },
    methods: {
      loadData(){
        this.api({ action: 'projects/get_project_data',data: {token: this.token }} ,(data) => {
        if(data.data){
          this.item = data.data;
            this.api({ action: 'applying/get',data: {token: this.token }} ,(data) => {
              if(data.data)
              {
                this.applying_data = data.data;
                 this.loaded = true;
              }
              else{
                return this.$router.push('/');
              }
            });
         
        }
      });
      },
      async finish()
      {
        // For 'improve' bid process, use a different API endpoint
        const action = 'applying/finish';
        
        await this.api({ action, data: {token: this.token }});
        this.$router.push('/list');
        const message = this.item.bid_step === 'improve' ? 'שיפור ההצעה נשלח בהצלחה' : 'המכרז נשלח בהצלחה';
        this.alert(message);  
      },
      moveStep(to){
        let step = this.currentStep;
        if (to == "back") {
          if (step && +step > 1 ) {
            step--
          } else {
            return;
          }
        } else {
          if(step <= 0) {
            // For 'improve' bid process, start at step 2
            step = this.item.bid_step === 'improve' ? 2 : 1;
          } else {
            step++;
          }
        }
        
        // Check if we've reached the end of the steps
        const maxStep = this.steps[this.steps.length - 1].stepNum;
        if (step > maxStep) {
          step = maxStep;
        }
       
        this.$router.push('/applying_project/'+ step +'/'+ this.token);
      },
      handleNext(data ,next = true){
        this.api({ action: 'applying/save_bid',data: {token: this.token ,aggrements:data }} ,(data) => {
          if(data.data){
            if(next)
            {
              this.moveStep('next');
            }
          }
        });
      },
      handleFail(message) {
        this.alert(message || 'שגיאה בתהליך התשלום');
      }
    }
}
</script>

<style lang="scss" scoped>
.content_wrapper{
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
}
#main_create_project { 
}

.improve-final-step {
  padding: 30px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
  
  h3 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 25px;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .submit-btn {
    background-color: #4caf50;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
    
    &:hover {
      background-color: #45a049;
    }
  }
}
@media(max-width:768px){
  :deep(.breadcrumbs){
      flex-wrap: wrap;
      padding:0px 10px 10px 10px;
      
      .breadcrumbs__item{
        font-size: 16px !important;
      }
    }
    #main_apply_project{
      padding:0 10px;
      .haed{
        .title_btn{
        
        align-items: flex-end;
        .title{
          width: fit-content;
          font-size: 28px;
          margin-bottom: 5px;
        }
        a.exit_btn{
              padding:5px;
              font-size: 14px;
              height: fit-content;
              width: fit-content;
            }
      }
      .steps{
       
        justify-content: space-around;
        
            .step{
              width: 30%;
              
              font-size: 16px;
            }
            span{
              font-size: 16px;
            }
      }
      }
       
         :deep( .floors_container) {
              .head{
                 border-bottom: 0 solid transparent !important;
                 ul{
                  display: none;
                 }
              }
       
    
    }
    .arrow_container{
      display: none;
    }
  
  :deep(.main_contract_manager.card) {
    padding:20px 10px !important;

    .list_p{
      padding:20px 10px;

      ul li::before{
        width:20px;
      }
    }
   .contract_types_nav {
     .nav_list{
        flex-wrap: wrap;
        display: flex;
        gap:10px;
       justify-content: space-between;

        .nav_item {
          width: 45%;
          justify-content: center;
        }
      }
  } 
  }
  :deep(.main_settings_contract){
    padding: 10px;

    
      .row{
        flex-direction: row;
        flex-wrap: wrap;
        padding: 20px 0px 0px 0px;
        justify-content: center;
        gap:20px;

      }

      .edit_row{
        flex-direction: row;
        flex-wrap: wrap;
        gap: var(--gap_small);
        justify-content: center;
        margin-top: 20px;
        padding:  0px;

        .gallery_input_wrapper{
          width: 100%;
          margin-bottom: 20px;
          
          .title{
            font-size: 16px;
            margin-bottom: var(--gap_small);
          }
        }

        .note_con{
          min-width: 100%;

          .title{
            font-size: 16px;
          }
        }
        .trash_btn_container, .edit_btn_container{
          margin-top: 0;
          max-width: 35px;
          max-height: 36px;
          padding: 0;
          margin-bottom: 20px;
        }
        .edit_btn_container.btn_b{
          max-width: 36px;
          max-height: 33px !important;
          padding: 0;

          .icon.edit_b_icon{
            max-width: 20px;
            max-height: 20px;
          }
        }
        
       
      }
    .part_note{
          height: 100px;
          width: 100%;
          max-height: 250px;
          overflow-y: auto;
          padding:0 10px;
         
        }


        .legal_details{
          .content{
            padding:0 10px !important;
          }
        }

        .part_note_container{
          flex-direction: column;
          padding:20px 0; 

          .title{
            font-size: 18px;
          }
  
          .show-unshow.unshow{
            display:none;
          }
          .show-unshow{
            display:flex;
          }
  
    } 
  }
  }
  .btn.send-btn{
    font-size: 16px;
    padding:12px 25px;
    justify-self: center;
  }
  .content{
    padding-bottom:20px;

    .content_wrapper{
      margin:20px 0;
      font-size: 18px;
  }
}  
            

    
    
}
</style>